module.exports = __webpack_public_path__ + "static/img/pure-pescado.367fc8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/pure-pescado.png
// module id = 245
// module chunks = 1